import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'

import './layout.scss'

const Layout = ({ children }) => (
  <React.Fragment>
    <StaticQuery
      //DS - query is not being used - I don't know where this is coming from? values hardcoded below
      //SS - queried data is from gatsby-config. Other page meta can be added to that object, or the query can be removed altogether. https://www.gatsbyjs.org/docs/gatsby-config/ :)
      query={graphql`
        query SiteTitleQuery {
          site {
            siteMetadata {
              title
            }
          }
        }
      `}
      render={data => (
        <>
          <Helmet
            title={
              'Vincenc Kramář, Notes on Picasso’s exhibition at the Thannhauser Gallery, 1913 | The Metropolitan Museum of Art'
            }
            //title={data.site.siteMetadata.title}
            meta={[
              {
                name: 'description',
                content:
                  "A digital facsimile, with transcription and translation, of notes by Vincenc Kramář, on Picasso's 1913 exhibition at Heinrich Thannhauser's Moderne Galerie in Munich. The original notes are located in the collection of the Department of Documentation, Ústav dějin umění Akademie věd České republiky (Institute of Art History, Czech Academy of Sciences), Prague.",
              },
              { property: 'fb:admins', content: '100000423552506' },
              {
                property: 'og:site_name',
                content: 'The Metropolitan Museum of Art',
              },
              { property: 'og:type', content: 'website' },
              {
                property: 'og:title',
                content:
                  'Vincenc Kramář, Notes on Picasso’s exhibition at the Thannhauser Gallery, 1913',
              },
              {
                property: 'og:description',
                content:
                  "A digital facsimile, with transcription and translation, of notes by Vincenc Kramář, on Picasso's 1913 exhibition at Heinrich Thannhauser's Moderne Galerie in Munich. The original notes are located in the collection of the Department of Documentation, Ústav dějin umění Akademie věd České republiky (Institute of Art History, Czech Academy of Sciences), Prague.",
              },
              {
                property: 'og:url',
                content:
                  'https://metmuseum.org/art/libraries-and-research-centers/leonard-lauder-research-center/research/digital-archives/kramar-project',
              },
            ]}
            link={[
              {
                rel: 'canonical',
                href:
                  'https://metmuseum.org/art/libraries-and-research-centers/leonard-lauder-research-center/research/digital-archives/kramar-project',
              },
            ]}
            script={[
              {
  					    type: 'text/javascript',
  					    innerHTML:
                  "(function(w, d, s, l, i) {w[l] = w[l] || [];w[l].push({'gtm.start': new Date().getTime(),event: 'gtm.js'});var f = d.getElementsByTagName(s)[0],j =d.createElement(s),dl = l != 'dataLayer' ? '&l=' + l : '';j.async = true;j.src ='https://www.googletagmanager.com/gtm.js?id=' + i + dl;f.parentNode.insertBefore(j, f);})(window, document, 'script', 'dataLayer', 'GTM-MSDMZ4');"
              }]}
          >
            <html lang="en" />
          </Helmet>
          {children}
          <div className="mobile-warning">
            This research tool is optimized for larger screens. <br />
            If you would like to use it, please view it in a larger window.
          </div>
        </>
      )}
    />
  </React.Fragment>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
